import React, { createContext, useContext, useEffect, useState } from 'react';
import { io } from 'socket.io-client';
import { useAuth } from './AuthContext';

const WhatsAppSocketContext = createContext(null);

const SOCKET_SERVER_URL = process.env.REACT_APP_API_URL 
  ? process.env.REACT_APP_API_URL.replace('/api', '') 
  : 'http://localhost:5000'; // Default backend server port is 5000/5001. Fallback here.

export const WhatsAppSocketProvider = ({ children }) => {
  const { user } = useAuth();
  const [socket, setSocket] = useState(null);
  const [isConnected, setIsConnected] = useState(false);

  useEffect(() => {
    if (!user || !user.tenantId) {
      return;
    }

    // Connect to Socket.io Server
    const socketInstance = io(SOCKET_SERVER_URL, {
      transports: ['websocket', 'polling'],
      autoConnect: true
    });

    socketInstance.on('connect', () => {
      console.log('WhatsApp Socket client connected:', socketInstance.id);
      setIsConnected(true);
      
      // Join the tenant's private room
      socketInstance.emit('join_tenant', user.tenantId);
    });

    socketInstance.on('disconnect', () => {
      console.log('WhatsApp Socket client disconnected');
      setIsConnected(false);
    });

    setSocket(socketInstance);

    return () => {
      socketInstance.disconnect();
    };
  }, [user]);

  return (
    <WhatsAppSocketContext.Provider value={{ socket, isConnected }}>
      {children}
    </WhatsAppSocketContext.Provider>
  );
};

export const useWhatsAppSocket = () => {
  const context = useContext(WhatsAppSocketContext);
  if (!context) {
    throw new Error('useWhatsAppSocket must be used within a WhatsAppSocketProvider');
  }
  return context;
};
